import { RouteLocationRaw } from 'vue-router';
import routerInstance from '~/plugins/router';

export const executeRoute = async (route: RouteLocationRaw): Promise<boolean> => {
    return (await routerInstance.push(route)) == null;
};
